import * as Yup from "yup";
import { useMemo } from "react";
import { useLocStore } from "../../../localization";
import { LocContext } from "../../../localization/LocContext";

export const useApplyWithoutProfileConsentSchema = (
  hasCoverLetter: boolean,
  hasCv: boolean
) => {
  const L = useLocStore(LocContext.CV);

  // Return null if localization data is not yet available.
  // This ensures that all required strings are loaded before building the validation schema.
  // Without this check, the schema may be created with empty error messages,
  // causing users not to see the correct validation messages.
  if (!L) {
    return { APPLY_WITHOUT_PROFILE_CONSENT_VALIDATION: null };
  }

  const consentErrorMessage = L.id("0c810d4099de").loc(
    "Du må akseptere samtykkeerklæringen."
  );
  const applicationTextErrorMessage = L.id("9ec84af715ab").loc(
    "Søknadstekst er påkrevd for å søke på denne stillingen."
  );
  const attachmentsErrorMessage = L.id("ab957f02be2e").loc(
    "Vedlegg med CV er påkrevd for å søke på denne stillingen."
  );

  const APPLY_WITHOUT_PROFILE_CONSENT_VALIDATION = useMemo(() => {
    return Yup.object().shape({
      applicationText: Yup.string().when([], () =>
        hasCoverLetter
          ? Yup.string().required(applicationTextErrorMessage)
          : Yup.string()
      ),
      attachments: Yup.array()
        .of(Yup.mixed())
        .when([], () =>
          hasCv
            ? Yup.array()
                .of(Yup.mixed().required())
                .min(1, attachmentsErrorMessage)
            : Yup.array().of(Yup.mixed())
        ),
      consent: Yup.boolean()
        .oneOf([true], consentErrorMessage)
        .required(consentErrorMessage)
        .nullable(),
    });
  }, [hasCoverLetter, hasCv, L.changeIndicator]);

  return { APPLY_WITHOUT_PROFILE_CONSENT_VALIDATION };
};

export interface ApplyWithoutProfileConsentFormValues {
  consent: boolean;
  applicationText: string;
  attachments: File[];
}
